// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/gnosis-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { AccountFromJSON, BaseInfoFromJSON, BaseTxHistoryTxFromJSON, DoRpcRequest200ResponseFromJSON, DoRpcRequestRequestToJSON, EstimateGasBodyToJSON, GasEstimateFromJSON, GasFeesFromJSON, SendTxBodyToJSON, TokenMetadataFromJSON, TxFromJSON, } from '../models';
/**
 *
 */
export class V1Api extends runtime.BaseAPI {
    /**
     * Makes a jsonrpc request to the node.
     */
    async doRpcRequestRaw(requestParameters, initOverrides) {
        if (requestParameters.doRpcRequestRequest === null || requestParameters.doRpcRequestRequest === undefined) {
            throw new runtime.RequiredError('doRpcRequestRequest', 'Required parameter requestParameters.doRpcRequestRequest was null or undefined when calling doRpcRequest.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/jsonrpc`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DoRpcRequestRequestToJSON(requestParameters.doRpcRequestRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DoRpcRequest200ResponseFromJSON(jsonValue));
    }
    /**
     * Makes a jsonrpc request to the node.
     */
    async doRpcRequest(requestParameters, initOverrides) {
        const response = await this.doRpcRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Estimate gas cost of a transaction
     */
    async estimateGasRaw(requestParameters, initOverrides) {
        if (requestParameters.estimateGasBody === null || requestParameters.estimateGasBody === undefined) {
            throw new runtime.RequiredError('estimateGasBody', 'Required parameter requestParameters.estimateGasBody was null or undefined when calling estimateGas.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/gas/estimate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EstimateGasBodyToJSON(requestParameters.estimateGasBody),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GasEstimateFromJSON(jsonValue));
    }
    /**
     * Estimate gas cost of a transaction
     */
    async estimateGas(requestParameters, initOverrides) {
        const response = await this.estimateGasRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get account details by address
     */
    async getAccountRaw(requestParameters, initOverrides) {
        if (requestParameters.pubkey === null || requestParameters.pubkey === undefined) {
            throw new runtime.RequiredError('pubkey', 'Required parameter requestParameters.pubkey was null or undefined when calling getAccount.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/account/{pubkey}`.replace(`{${"pubkey"}}`, encodeURIComponent(String(requestParameters.pubkey))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => AccountFromJSON(jsonValue));
    }
    /**
     * Get account details by address
     */
    async getAccount(requestParameters, initOverrides) {
        const response = await this.getAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the current recommended gas fees to use in a transaction  * For EIP-1559 transactions, use `maxFeePerGas` and `maxPriorityFeePerGas` * For Legacy transactions, use `gasPrice`
     */
    async getGasFeesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/gas/fees`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GasFeesFromJSON(jsonValue));
    }
    /**
     * Get the current recommended gas fees to use in a transaction  * For EIP-1559 transactions, use `maxFeePerGas` and `maxPriorityFeePerGas` * For Legacy transactions, use `gasPrice`
     */
    async getGasFees(initOverrides) {
        const response = await this.getGasFeesRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get information about the running coinstack
     */
    async getInfoRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BaseInfoFromJSON(jsonValue));
    }
    /**
     * Get information about the running coinstack
     */
    async getInfo(initOverrides) {
        const response = await this.getInfoRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get token metadata
     */
    async getTokenMetadataRaw(requestParameters, initOverrides) {
        if (requestParameters.contract === null || requestParameters.contract === undefined) {
            throw new runtime.RequiredError('contract', 'Required parameter requestParameters.contract was null or undefined when calling getTokenMetadata.');
        }
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getTokenMetadata.');
        }
        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling getTokenMetadata.');
        }
        const queryParameters = {};
        if (requestParameters.contract !== undefined) {
            queryParameters['contract'] = requestParameters.contract;
        }
        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }
        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/metadata/token`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => TokenMetadataFromJSON(jsonValue));
    }
    /**
     * Get token metadata
     */
    async getTokenMetadata(requestParameters, initOverrides) {
        const response = await this.getTokenMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get transaction details
     */
    async getTransactionRaw(requestParameters, initOverrides) {
        if (requestParameters.txid === null || requestParameters.txid === undefined) {
            throw new runtime.RequiredError('txid', 'Required parameter requestParameters.txid was null or undefined when calling getTransaction.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/tx/{txid}`.replace(`{${"txid"}}`, encodeURIComponent(String(requestParameters.txid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => TxFromJSON(jsonValue));
    }
    /**
     * Get transaction details
     */
    async getTransaction(requestParameters, initOverrides) {
        const response = await this.getTransactionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get transaction history by address
     */
    async getTxHistoryRaw(requestParameters, initOverrides) {
        if (requestParameters.pubkey === null || requestParameters.pubkey === undefined) {
            throw new runtime.RequiredError('pubkey', 'Required parameter requestParameters.pubkey was null or undefined when calling getTxHistory.');
        }
        const queryParameters = {};
        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }
        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }
        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }
        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/account/{pubkey}/txs`.replace(`{${"pubkey"}}`, encodeURIComponent(String(requestParameters.pubkey))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BaseTxHistoryTxFromJSON(jsonValue));
    }
    /**
     * Get transaction history by address
     */
    async getTxHistory(requestParameters, initOverrides) {
        const response = await this.getTxHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Sends raw transaction to be broadcast to the node.
     */
    async sendTxRaw(requestParameters, initOverrides) {
        if (requestParameters.sendTxBody === null || requestParameters.sendTxBody === undefined) {
            throw new runtime.RequiredError('sendTxBody', 'Required parameter requestParameters.sendTxBody was null or undefined when calling sendTx.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/send`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendTxBodyToJSON(requestParameters.sendTxBody),
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Sends raw transaction to be broadcast to the node.
     */
    async sendTx(requestParameters, initOverrides) {
        const response = await this.sendTxRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
